import { getShopInfo, bindShop } from "../../../api/wxshop/shop.js";

let modules = {
	namespaced: true,
	state: {
	},
	mutations: {
	},
	actions: {
		getShopInfoAction(conText, payload) {
			getShopInfo(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		bindShopAction(conText, payload) {
			bindShop(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
	}
}
export default modules;
